import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IRegionLookupListTableRow } from '../../../../../interfaces/lookup/region';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchRegions } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const RegionLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { regions } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IRegionLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/admin/lookup-lists/region/${record.id}`)} />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (regions.model.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/region', { replace: true });
        }
    }, [regions.model.updateStatus]);

    useEffect(() => {
        dispatch(fetchRegions());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (regions.model.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [regions.model.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage regions lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Regions',
                        path: '/admin/lookup-lists/region',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/region/add')}>
                        Add new option
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={regions.model.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={regions.model.data.map((option, i) => {
                        return { ...option, key: i } as IRegionLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 50,
                    }}
                />
            </div>
        </div>
    );
};
